import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.simAndLineManagement;
const path = 'line-management';
const title = 'PAGE.MOBILE.SIM_AND_LINE_MANAGEMENT.LINE.TITLE';

const res = [
  'actions',
  'actions.viewAll',
  'actions.copyLineId',
  'actions.simSwap',
  'actions.editProperties',
  'actions.setPersistency',
  'actions.sendMessage',
  'actions.editLineStatus',
  'actions.deactivateLine',
  'actions.activateLine',
  'actions.terminateLine',
  'actions.bulkActions',
];

export const MobileSimAndLineManagementLineTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
